export default __webpack_public_path__ + "static/media/news35.5b55cd41.jpg";